import { render, staticRenderFns } from "./FormPage5.vue?vue&type=template&id=4881acaf&scoped=true&"
import script from "./FormPage5.vue?vue&type=script&lang=js&"
export * from "./FormPage5.vue?vue&type=script&lang=js&"
import style0 from "./FormPage5.vue?vue&type=style&index=0&id=4881acaf&scoped=true&lang=css&"
import style1 from "./FormPage5.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4881acaf",
  null
  
)

export default component.exports